import { render, staticRenderFns } from "./client-v2.vue?vue&type=template&id=0b53fb94"
import script from "./client-v2.vue?vue&type=script&lang=js"
export * from "./client-v2.vue?vue&type=script&lang=js"
import style0 from "./client-v2.vue?vue&type=style&index=0&id=0b53fb94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports